import React, { useState } from "react";
import { Image, OverlayTrigger, Popover } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/pro-solid-svg-icons";
import { mainMenuList, othersMenuList } from "../../utils";
import { Link } from "react-router-dom";
import tenantConfig from "../../mocks/tenantOne.json";
import permissions from "../../mocks/menuPermissions.json";
import { camelCase, isEmpty, startCase } from "lodash";
import AddToolTip from "../AddToolTip/AddToolTip";
const SideBarContent = ({ selectedMenu, role }) => {
  const userRoleMenuList = othersMenuList.filter(
    (e) =>
      tenantConfig["menuItems"]?.includes(camelCase(e.name)) &&
      permissions[role]["menuItems"][camelCase(e.name)]?.includes("R")
  );
  const selectedItem = userRoleMenuList?.find((e) =>
    e.menuList.includes(selectedMenu)
  );
  return (
    <div className="d-flex sidebar-content flex-column">
      <div className="minimized-content">
        <span className="core-icon">
          <Image
            src={`/assets/icons/svg/core.svg`}
            width="60px"
            height="100%"
          />
        </span>
        <div className="menu-icons">
          {mainMenuList.map((e, i) => {
            const selected = e.menuList.includes(selectedMenu)
              ? "selected"
              : "unselected";
            return (
              tenantConfig["menuItems"]?.includes(camelCase(e.name)) &&
              permissions[role]["menuItems"][camelCase(e.name)]?.includes(
                "R"
              ) && (
                <Link to={e.route} className={`menu-icons-content ${selected}`}>
                  <FontAwesomeIcon icon={e.icon} />
                  <span className="menu-font-size text-nowrap">
                    {startCase(e.label.length) < 9 ? (
                      startCase(e.label)
                    ) : (
                      <AddToolTip name={startCase(e.label)}>
                        {startCase(e.label).slice(0, 9)}...
                      </AddToolTip>
                    )}
                  </span>
                </Link>
              )
            );
          })}

          {selectedItem && userRoleMenuList?.length > 1 && (
            <Link
              to={selectedItem.route}
              className={`menu-icons-content ${
                selectedItem ? "selected" : "unselected"
              }`}
            >
              <FontAwesomeIcon icon={selectedItem.icon} />
              <span className="menu-font-size text-nowrap">
                {startCase(selectedItem.name.length) < 7 ? (
                  startCase(selectedItem.name)
                ) : (
                  <AddToolTip name={startCase(selectedItem.name)} >
                    {startCase(selectedItem.name).slice(0, 7)}...
                  </AddToolTip>
                )}
              </span>
            </Link>
          )}
          {userRoleMenuList?.length > 1 ? (
            <OverlayTrigger
              trigger="click"
              rootClose
              key={"right"}
              placement={"right"}
              overlay={
                <Popover>
                  <Popover.Content className="expanded-others-menu">
                    <div className="other-menu-contents">
                      {userRoleMenuList.map((e, i) =>
                        !e.menuList.includes(selectedMenu) ? (
                          <Link to={e.route} className="menu-icons-content ">
                            <FontAwesomeIcon icon={e.icon} />
                            <span className="menu-font-size text-nowrap">
                              {startCase(e.name.length) < 9 ? (
                                startCase(e.name)
                              ) : (
                                <AddToolTip name={startCase(e.name)}>
                                  {startCase(e.name).slice(0, 9)}...
                                </AddToolTip>
                              )}
                            </span>
                          </Link>
                        ) : null
                      )}
                    </div>
                  </Popover.Content>
                </Popover>
              }
            >
              <div
                className="menu-icons-content other-icon"
                // onClick={sidebarMouseoverHandler}
              >
                <FontAwesomeIcon icon={faEllipsisH} />
                <span className="menu-font-size">Others</span>
              </div>
            </OverlayTrigger>
          ) : (
            userRoleMenuList?.length === 1 &&
            userRoleMenuList.map((e) => (
              <Link
                to={e.route}
                className={`menu-icons-content ${
                  e.menuList.includes(selectedMenu) ? "selected" : "unselected"
                }`}
              >
                <FontAwesomeIcon icon={e.icon} />
                <span className="menu-font-size text-center">{e.name}</span>
              </Link>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default SideBarContent;
